import React, { useState } from 'react'
import clsx from 'clsx'

import classes from './Accordion.module.scss'
import ArrowDownIcon from '../ArrowDownIcon'

type AccordionProps = {
  title: React.ReactNode
  className?: string
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => setIsOpen((value) => !value)

  return (
    <details
      className={clsx(classes.root, className, {
        [classes.open]: isOpen,
      })}
      open={isOpen}
      onToggle={handleToggle}
    >
      <summary className={classes.summary}>
        <div className={classes.title}>
          {title}
          <ArrowDownIcon className={classes.arrowIcon} />
        </div>
      </summary>

      <div>{children}</div>
    </details>
  )
}

export default Accordion
